import React from 'react';
import { FiEye } from 'react-icons/fi';
import { Empty, Spinner } from '../ui';
import { QIRA } from '../Robot/Gia';
import { useWorkspace } from './Workspace';
import { t } from '../i18n';

/** Wraps a screen: no access -> explanation, view only -> a notice (the API refuses the changes anyway). */
export default function Guard({ screen, children, adminOnly }) {
  const { levels, can } = useWorkspace();
  if (levels === null) return <Spinner />; // never show a screen (and fire its requests) before knowing the access
  if (levels === false && !adminOnly) return children; // could not load: the API enforces regardless
  if (!can(screen) || (adminOnly && !can('permissions'))) { // adminOnly: reserved for system administrators and cannot be given to a role
    return (
      <div className="page">
        <Empty icon={<img className="empty-gia" src={QIRA.bust} alt="QIRA" />} title={t("You do not have access to this screen")}>{t("Ask an administrator to give you access.")}</Empty>
      </div>
    );
  }
  return (
    <>
      {!can(screen, 'edit') && screen !== 'dashboard' && (
        <div className="ro-banner" role="status"><FiEye /> {t("You have read-only access to this screen.")}</div>
      )}
      {children}
    </>
  );
}
